import axios from 'axios'
import React, { useEffect, useState } from 'react'
import authService from '../../../Components/Login/auth.service'
//const uuidv4 = require('uuid/v4')

export default function Modal() {
  const uuidv4 = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(16) + '-' + Math.random().toString(16).slice(2);
  var user = authService.getCurrentUser()
  const [gerencias, setGerencia] = useState([])
  const [modal, setModal] = useState(false)
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
        '/api/v1/gerencia/list/' +
        user[0].IdEmpresa
      )
      .then(response => {
        setGerencia(response.data)
      })
  }, [])

  const toggleModal = () => {
    if (parseInt(sessionStorage.uniSubUnidades) === 1) {
      setModal(!modal)
    }
    else {
      alert("Essa unidade não permite cadastro de Novos Locais.")
    }
  }

  if (modal) {
    document.body.classList.add('active-modal')
  } else {
    document.body.classList.remove('active-modal')
  }
  let newDate = new Date()

  const [campos, setCampos] = useState({
    IdLocalArea: '',
    IdEmpresa: user[0].IdEmpresa,
    IdUnidade: sessionStorage.IdUnidade,
    IdGerencia: 0,
    locDescricao: '',
    locReferencia: '',
    locStatus: 1,
    locObservacoes: '',
    locCriadoPor: user[0].pesEmail,
    locCriadoEm: newDate,
    locAlteradoPor: user[0].pesEmail,
    locAlteradoEm: newDate,
    locCodigoGUID: uuidv4
  })
  function handleInputChange(event) {
    if (event.target.name === 'locStatus') {
      if (event.target.checked) {
        campos[event.target.name] = 1
      } else {
        campos[event.target.name] = 0
      }
    } else {
      campos[event.target.name] = event.target.value
    }
    setCampos(campos)
  }
  function handleFormSubmit(event) {
    event.preventDefault()
    axios
      .post(process.env.REACT_APP_API_URL + '/api/v1/area', campos)
      .then(response => {
        alert(response.data.message)
        window.location.reload()
      })
  }
  return (
    <>
      <button onClick={toggleModal} className="buttonModalPadraoPes" Visible={parseInt(sessionStorage.uniSubUnidades) === 1} >
        Novo Local
      </button>

      {modal && (
        <div className="modalArea">
          <div onClick={toggleModal} className="overlay"></div>
          <div className="modalPadrao-content">
            <div className="cxTituloPadrao">
              <h1>
                NOVO LOCAL
                <hr className="hrTitleModal" />
              </h1>
              <button onClick={toggleModal}>X</button>
            </div>

            <form onSubmit={handleFormSubmit}>
              <label>Nome:</label>
              <input
                type="text"
                id="fname"
                defaultValue={campos.locDescricao}
                name="locDescricao"
                onChange={handleInputChange}
              ></input>

              <label>Referência:</label>
              <input
                type="text"
                id="fname"
                defaultValue={campos.locReferencia}
                name="locReferencia"
                onChange={handleInputChange}
              ></input>

              <label>Observações:</label>
              <textarea
                type="text"
                id="fname"
                name="locObservacoes"
                defaultValue={campos.locObservacoes}
                row="none"
                onChange={handleInputChange}
                maxLength="500"
              ></textarea>
              <div className="caixaSalvarPadrao">
                <div className="InputAuthorization4">
                  <label>
                    <input
                      name="locStatus"
                      type="checkbox"
                      defaultChecked={!!campos.locStatus}
                      onChange={handleInputChange}
                    />
                    <span>Status</span>
                  </label>
                </div>
                <button type="submit">Salvar Registro</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  )
}
